import { ProductCategorySourceSchema } from "@redotech/redo-inventory-common/product-category";
import * as z from "zod";
import { ProductTaxonomyItemSchema } from "./get-product-taxonomy";

export const searchProductTaxonomy = {
  name: "searchProductTaxonomy" as const,
  input: z.object({ source: ProductCategorySourceSchema, query: z.string() }),
  output: z.object({ results: z.array(ProductTaxonomyItemSchema) }),
};
